export enum DeliveryExperience {
    Unspecified,

    DeliveryConfirmationWithAdultSignature,
    DeliveryConfirmationWithSignature, // Required for DPD (UK).
    DeliveryConfirmationWithoutSignature,
    NoTracking,
}